// https://blockly-demo.appspot.com/static/demos/blockfactory/index.html#pbvgpo
import { insideBeforePurchase } from '../../relationChecker';
import { translate } from '../../../../../common/i18n';
import config from '../../../../common/const';
import theme from '../../theme';

Blockly.Blocks.purchase_no_barrier = {
    init: function init() {
        this.appendDummyInput()
            .appendField(translate('Purchase'))
            .appendField(new Blockly.FieldDropdown(config.lists.PURCHASE_NO_BARRIER), 'CONTRACT_TYPE');

        this.appendValueInput('DURATION').setCheck('Number')
            .appendField(`${translate('Duration')  }:`)
            .appendField(new Blockly.FieldDropdown(config.lists.PURCHASE_DURATION_UNITS), 'DURATION_UNIT');

        this.appendValueInput('AMOUNT').setCheck('Number')
            .appendField(`${translate('Stake')  }:`)
            .appendField(new Blockly.FieldDropdown(config.lists.CURRENCY), 'CURRENCY_LIST');

        this.setPreviousStatement(true, 'Purchase');
        this.setColour(theme.subBlockColor);
        this.setTooltip(translate('Purchases a chosen contract.'));
    },
    onchange: function onchange(ev) {
        insideBeforePurchase(this, ev, 'Purchase');
        this.childBlocks_.map(a => {a.svgPath_.style.fill = theme.indicatorsColor;a.svgPathDark_.style.display = 'none';})
        for (let index = 0; index < this.svgGroup_.children.length; index++) {
            const a = this.svgGroup_.children[index];
            if(a.tagName === 'g' && (a.classList.length === 0)) {
                a.children[3].children[0].style.fill = theme.indicatorColorAccent;
            } else if(a.tagName === 'g' && a.classList[0] === 'blocklyEditableText') {
                a.children[0].style.fill = theme.underBlockColor;
            } else if(a.tagName === 'g' && a.classList[0] === 'blocklyDraggable') {
                a.children[1].style.fill = theme.subBlockColor;
            }
        }
    },
};
Blockly.JavaScript.purchase_no_barrier = block => {
    const contractType = block.getFieldValue('CONTRACT_TYPE');
    const duration = Blockly.JavaScript.valueToCode(block, 'DURATION', Blockly.JavaScript.ORDER_ATOMIC);
    const durationUnit = block.getFieldValue('DURATION_UNIT');
    const amount = Blockly.JavaScript.valueToCode(block, 'AMOUNT', Blockly.JavaScript.ORDER_ATOMIC);
    const code = `Bot.purchaseSingle({ contractType: '${contractType}', duration: ${duration}, durationUnit: '${durationUnit}', barrier: undefined, amount: ${amount}});`;
    return code;
};



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/before_purchase/purchase_no_barrier.js